<template>
  <el-row :gutter="20" class="navbar">
      <el-col :span="2" :offset="2"><img class="logo_img" src="@/assets/logo.png"></el-col>
      <el-col :span="20">
      <el-menu default-active="/home" active-text-color="#409eff" mode="horizontal" router>
        <el-menu-item index="/home">首页</el-menu-item>
        <el-menu-item index="/doc">资源中心</el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>
<script>

export default {
  data() {
      return {
      };
    },
}
</script>